import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, TrendingUp, Trees, Axe, Users } from "lucide-react";

const ProprietairesSection = () => {
  const cards = [
    {
      icon: TrendingUp,
      title: "Estimer ma forêt",
      description: "Obtenez une première analyse de votre forêt ou de votre parcelle boisée et identifiez les options de valorisation possibles.",
      cta: "Demander une estimation",
      link: "/estimation-foret",
      testId: "card-estimation"
    },
    {
      icon: Trees,
      title: "Vendre ma forêt",
      description: "Vous souhaitez céder une forêt, un bois ou une parcelle forestière ? Nous étudions votre bien et les solutions de transaction adaptées.",
      cta: "Étudier ma vente",
      link: "/vendre-parcelle-bois",
      testId: "card-vendre"
    },
    {
      icon: Axe,
      title: "Valoriser mes bois",
      description: "Vous envisagez une coupe ou la vente de bois sur pied ? Nous analysons votre besoin et pouvons vous orienter vers les professionnels adaptés.",
      cta: "Étudier mes bois",
      link: "/vendre-bois-sur-pied",
      testId: "card-bois"
    },
    {
      icon: Users,
      title: "Succession ou indivision",
      description: "Héritage, indivision ou parcelles dispersées : nous vous aidons à identifier une solution foncière cohérente.",
      cta: "Étudier ma situation",
      link: "/successions-forestieres",
      testId: "card-succession"
    }
  ];

  return (
    <section id="proprietaires" className="py-20 md:py-28 bg-cream" data-testid="proprietaires-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-sans font-semibold mb-4">
            Propriétaires Forestiers
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-forest mb-6">
            Que souhaitez-vous faire de votre forêt ?
          </h2>
          <div className="w-16 h-px bg-gold mx-auto mb-6" />
          <p className="font-sans text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Sylva Invest accompagne les propriétaires forestiers dans la valorisation, la transmission et la cession de leurs actifs forestiers.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {cards.map((card, index) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Link
                to={card.link}
                className="block h-full bg-white p-8 border border-gray-100 hover:border-gold transition-all duration-300 group"
                data-testid={card.testId}
              >
                <card.icon className="w-10 h-10 text-gold mb-6" />
                <h3 className="font-serif text-xl text-forest mb-4 group-hover:text-gold transition-colors">
                  {card.title}
                </h3>
                <p className="font-sans text-sm text-gray-600 leading-relaxed mb-6">
                  {card.description}
                </p>
                <span className="inline-flex items-center font-sans text-sm font-medium text-forest group-hover:text-gold transition-colors">
                  {card.cta}
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProprietairesSection;
